import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import SellDeliveryNoteRefundStatusBar, { DeliveryNoteRefundCreateStatusBarProps, SellDeliveryNoteRefundStatusBarNew } from '../SellDeliveryNoteRefundStatusBar'
import SellDeliveryNoteRefundFinishedStepButtons, { SellDeliveryNoteRefundFinishedStepButtonsNew } from '../Steps/SellDeliveryNoteRefundFinishedStep/SellDNRefundFinishedStepButtons'

type SellDeliveryNoteRefundFinishedStepHeaderProps = & DeliveryNoteRefundCreateStatusBarProps & OrderStepButtonsBaseComponentProps

const SellDeliveryNoteRefundFinishedStepHeaderDecider: React.FC<SellDeliveryNoteRefundFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellDeliveryNoteRefundFinishedStepHeaderDefault} NewComponent={SellDeliveryNoteRefundFinishedStepHeaderNew} {...rest} />
    )
}

const SellDeliveryNoteRefundFinishedStepHeaderDefault: React.FC<SellDeliveryNoteRefundFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellDeliveryNoteRefundStatusBar {...rest} />
            <SellDeliveryNoteRefundFinishedStepButtons {...rest} />
        </div>
    )
}

const SellDeliveryNoteRefundFinishedStepHeaderNew: React.FC<SellDeliveryNoteRefundFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellDeliveryNoteRefundStatusBarNew {...rest} />
            <SellDeliveryNoteRefundFinishedStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellDeliveryNoteRefundFinishedStepHeaderDecider